export default __webpack_public_path__ + "static/media/image3.634c3a12.png";